import { handleErrorWithSentry, replayIntegration } from "@sentry/sveltekit";
import * as Sentry from "@sentry/sveltekit";
import { env } from "$env/dynamic/public";
import { User } from "$lib/User";
import { get } from "svelte/store";

Sentry.init({
    dsn: "https://a2593f8c76ca35410b01303d963dd110@o4507887980183552.ingest.de.sentry.io/4507888296656976",
    tracesSampleRate: env.NODE_ENV === "production" ? 1.0 : 0,
    initialScope: {
        user: {
            id: undefined,
            organization_id: undefined,
        },
    },
    beforeSend(event) {
        const user = get(User);
        if (user?.loginStatus === "yes") {
            event.user = {
                id: user.email ?? undefined,
                organization_id: user.organizationId ?? undefined,
            };
        }
        return event;
    },

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // If you don't want to use Session Replay, just remove the line below:
    integrations: [replayIntegration()],
    environment: env.PUBLIC_ENVIRONMENT ?? "production",
    denyUrls: [
        /https?:\/\/.*\/transcription\/dictations\/filter\/polling/,
        /https?:\/\/.*\/transcription\/dictation\/status\//,
    ],
});

// If you have a custom error handler, pass it to `handleErrorWithSentry`
export const handleError = handleErrorWithSentry();
